import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Icons,
} from '@commenda/kakashi';

interface CustomerRemoveModalProps {
  onRemoveCustomer: () => void;
  isOpen: boolean;
  onClose: () => void;
}

const CustomerRemoveModal = ({
  onRemoveCustomer,
  isOpen,
  onClose,
}: CustomerRemoveModalProps) => {
  const onDeleteCustomer = () => {
    onRemoveCustomer();
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        className="min-w-[600px] p-0"
        hideCloseIcon
        preventCloseOnOutsideClick
      >
        <DialogHeader className="border-b-0 pb-1">
          <div className="flex flex-col gap-4">
            <div className="flex items-center justify-center size-12 bg-bg-error rounded-lg">
              <Icons.Trash01 className="size-5 text-text-error" />
            </div>
            <DialogTitle>Delete customer profile?</DialogTitle>
          </div>
        </DialogHeader>

        <div className="px-6">
          <p className="txt-small-regular text-text-tertiary">
            Deleting this customer will:
          </p>
          <ul className="list-disc pl-6 mt-4 txt-small-regular text-text-tertiary space-y-2">
            <li>Not affect past transactions— those will remain exempt.</li>
            <li>Remove all exemptions linked to this customer.</li>
            <li>Permanently delete the profile from your records.</li>
          </ul>
          <p className="mt-4 txt-small-regular text-text-tertiary">
            This action cannot be undone. Are you sure you want to proceed?
          </p>
        </div>

        <DialogFooter className="border-t-0">
          <div className="flex gap-3 items-center justify-end">
            <Button
              variant="secondary"
              onClick={onClose}
              size="sm"
              type="button"
            >
              Cancel
            </Button>
            <Button
              size="sm"
              onClick={onDeleteCustomer}
              variant="destructive-primary"
              type="button"
            >
              Delete customer
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CustomerRemoveModal;
